import { motion } from "framer-motion";
import { formatDate, mediaUrl } from "@/lib/api";

const MediaCard = ({ post, index = 0 }) => (
  <motion.figure
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, delay: Math.min(index * 0.08, 0.4), ease: [0.22, 1, 0.36, 1] }}
    className="group rounded-2xl overflow-hidden bg-white border border-slate-200 shadow-sm hover:shadow-xl hover:shadow-purple-200/50 transition-shadow"
    data-testid={`gallery-item-${post.id}`}
  >
    {post.media_type === "video" ? (
      <video
        controls
        preload="metadata"
        src={mediaUrl(post.storage_path)}
        className="w-full aspect-video object-cover bg-slate-900"
        data-testid="gallery-video"
      />
    ) : (
      <div className="aspect-video overflow-hidden bg-slate-100">
        <img
          src={mediaUrl(post.storage_path)}
          alt={post.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
        />
      </div>
    )}
    <figcaption className="p-5">
      {post.event_date && (
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-purple-700">
          {formatDate(post.event_date)}
        </p>
      )}
      <h3 className="font-display font-bold text-slate-900 mt-1.5">{post.title}</h3>
      {post.description && (
        <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{post.description}</p>
      )}
    </figcaption>
  </motion.figure>
);

export default MediaCard;